import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import OrganizerFileIcon from "../../organizer/view/OrganizerFileIcon";

/**
 * ManuscriptAddBlockItem: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * List item component rendering a specific block type
 * with an icon, title and a description, for use in an action list.
 *
 * @param {*} props
 */
const ManuscriptAddBlockItem = props => (
  <div
    className={`ed-manuscript-add-item type-${props.type}`}
    onClick={() => props.typeSelected(props.type)}
    role="presentation"
  >
    <div className="icon">
      {/**
       * Returns the block type icon with width 16px (@2x: 32px)
       */}
      <OrganizerFileIcon documentType={props.type} block size={16} />
    </div>
    <div className="depiction">
      {/**
       * Returns the localized block type name and description as provided
       * in the i18n files.
       */}
      <b>
        <FormattedMessage id={`manuscript.${props.type}.title`} />
      </b>
      {props.showDescription ? (
        <p>
          <FormattedMessage id={`manuscript.${props.type}.description`} />
        </p>
      ) : null}
    </div>
  </div>
);

ManuscriptAddBlockItem.propTypes = {
  /**
   * type: String
   * Block type identifier (e.g. "blocks.text")
   */
  type: PropTypes.string.isRequired,

  /**
   * selectedType: (selectedType) => ()
   * Fired when a specific item is clicked / selected.
   */
  typeSelected: PropTypes.func.isRequired,

  /**
   * showDescription: Boolean
   * Displays a description if true
   */
  showDescription: PropTypes.bool
};

ManuscriptAddBlockItem.defaultProps = {
  showDescription: false
};

export default ManuscriptAddBlockItem;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptAddBlockItem.js